import axios from '../../../axios';
import VmsAccount from '../types/VmsAccount';
import VmsClient from '../types/VmsClient';
const vmsUrl = '/jobsearch/api/vms';

export const getVmsTypesList = () => axios.get(`${vmsUrl}/vmstypes`);
export const getAllConfiguredVmsList = (vmsName: string) =>
  axios.get(`${vmsUrl}/vendoraccountbyvms/${vmsName}`);
export const configureVms = (data: VmsAccount[]) =>
  axios.post(`${vmsUrl}/vendoraccountcreate`, data);
export const updatePassword = (data: VmsAccount) =>
  axios.post(`${vmsUrl}/update-vms-password`, data);
export const configureClient = (data: VmsClient[]) =>
  axios.post(`${vmsUrl}/vendoraccountclientcreate`, data);
export const deleteConfiguredVmsById = (clientId: string) =>
  axios.delete(`${vmsUrl}/deletevmsclient/${clientId}`);
export const deleteVmsAccount = (accountId: string) =>
  axios.delete(`${vmsUrl}/deletevmsaccount/${accountId}`);
export const resendVmsOtp = (data: VmsAccount) =>
  axios.post(`${vmsUrl}/generatevmsclientotp`, data);
export const validateOtp = (data: VmsAccount) => axios.post(`${vmsUrl}/validatevmsclientotp`, data);
export const pauseAccount = (data: VmsAccount) => axios.post(`${vmsUrl}/vmsaccountstartstop`, data);
export const getVmsDomain = () => axios.get(`${vmsUrl}/vmsdomain`);
